import LanguageSkillEdit from './LanguageSkillEdit';
import LanguageSkillCreate from './LanguageSkillCreate';

export default {
  name: 'language-skills',
  edit: LanguageSkillEdit,
  create: LanguageSkillCreate,
};
